import { render, staticRenderFns } from "./PlanOnboardSection.vue?vue&type=template&id=e389ad3c&scoped=true"
import script from "./PlanOnboardSection.vue?vue&type=script&lang=js"
export * from "./PlanOnboardSection.vue?vue&type=script&lang=js"
import style0 from "./PlanOnboardSection.vue?vue&type=style&index=0&id=e389ad3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e389ad3c",
  null
  
)

export default component.exports